/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectOne/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaSelectOne({
  children,
  viewPath = "/DesignSystem/TysiaSelectOne",
  alignSelf = "flex-start",
  parentRef,
  alignItems,
  flexDirection = "column",
  flexGrow = 0,
  flexShrink = 1,
  flexBasis,
  marginTop = 24,
  marginRight = 0,
  marginBottom = 0,
  marginLeft = 0,
  height,
  maxWidth,
  onMouseEnter,
  onMouseLeave,
  from,
  required,
  optionsWidth,
  optionValue,
  size,
  dock,
  focused,
  disabled,
  hovered,
  invalid,
  valid,
  selectedPlaceholder,
  clearFilterOnBlur,
  placeholder = "Select...",
  value,
  isSelected,
  isMultiChoice,
  allowEmptyChoice = true,
  onClick,
  onBlur,
  onFocus,
  onChange,
  onSubmit,
  onChangeFilter,
  valueFilter,
  onKeyUp,
  isShowingOptions,
  optionsRef,
  inputRef,
  fromCustom,
  onClickAddFilterAsCustomOption,
  isShowingAddFilterAsCustomOption,
  selected,
  isSelectedAll,
  isEmpty,
  onClickToggleAll,
  showSelectAll
  
}) {
  return (<React.Fragment
>
<div
  data-testid="TysiaSelectOne.Vertical"
  data-view-path={viewPath}
 innerRef={parentRef}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--as-1-mc7v': alignSelf,'--ai-2-mc7v': alignItems,'--fd-3-mc7v': flexDirection,'--fg-4-mc7v': flexGrow,'--fs-5-mc7v': flexShrink,'--fb-6-mc7v': typeof flexBasis === 'number' ? `${flexBasis}%` : flexBasis,'--mt-7-mc7v': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mr-8-mc7v': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mb-9-mc7v': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-10-mc7v': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--h-11-mc7v': typeof height === 'number' ? `${height}px` : height,'--mw-12-mc7v': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth}}
 className={`views-block ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 from={from}
 required={required}
 optionsWidth={optionsWidth}
 optionValue={optionValue}
 size={size}
 dock={dock}
 focused={focused}
 disabled={disabled}
 hovered={hovered}
 invalid={invalid}
 valid={valid}
 selectedPlaceholder={selectedPlaceholder}
 clearFilterOnBlur={clearFilterOnBlur}
 placeholder={placeholder}
 value={value}
 isSelected={isSelected}
 isMultiChoice={isMultiChoice}
 allowEmptyChoice={allowEmptyChoice}
 onClick={onClick}
 onBlur={onBlur}
 onFocus={onFocus}
 onChange={onChange}
 onSubmit={onSubmit}
 onChangeFilter={onChangeFilter}
 valueFilter={valueFilter}
 onKeyUp={onKeyUp}
 isShowingOptions={isShowingOptions}
 innerRef={optionsRef}
 inputRef={inputRef}
 fromCustom={fromCustom}
 onClickAddFilterAsCustomOption={onClickAddFilterAsCustomOption}
 isShowingAddFilterAsCustomOption={isShowingAddFilterAsCustomOption}
 selected={selected}
 isSelectedAll={isSelectedAll}
 isEmpty={isEmpty}
 onClickToggleAll={onClickToggleAll}
 showSelectAll={showSelectAll}
>
{children}
</Children>
</div>
</React.Fragment>)
}